<div class="page-container bg-white">
    <div class="grid-container">
        <app-self-serve-side-nav [navGroups]="navGroups"></app-self-serve-side-nav>
        <div class="self-serve-content">
            <router-outlet></router-outlet>
        </div>
        <!-- https://gethumi.atlassian.net/browse/SQE-7963 -->
        <!-- <app-self-serve-help></app-self-serve-help> -->
    </div>
</div>
